export default {
  "app.aboutus.beginners_guide": "Beginners Guide",
  "app.aboutus.capital_allocation_guide": "Capital Allocation Guide",
  "app.aboutus.company_qualification": "Company Qualification",
  "app.aboutus.contact_us": "Contact Us",
  "app.aboutus.help_center": "Help Center",
  "app.aboutus.registeration_agreement": "Registration Agreement",
  "app.aboutus.title": "About Us",
  "app.aboutus.trading_rules": "Trading Rules",
  "app.account_details.addFund": "Additional Funding",
  "app.account_details.addMar": "Additional Bond",
  "app.account_details.applyAmount": "Application amount",
  "app.account_details.applysettle": "Apply for settlement",
  "app.account_details.applysettle1": "Are you sure you want to settle this contract?",
  "app.account_details.availablecredit": "Available Credit (USD)",
  "app.account_details.currentPL": "Current profit and loss (USD)",
  "app.account_details.days": "Trade days",
  "app.account_details.funddetail": "Fund details",
  "app.account_details.holdingRatio": "Holding ratio",
  "app.account_details.lossstop": "Loss stop-loss line",
  "app.account_details.losswarn": "Loss warning line",
  "app.account_details.managefee": "Management fee",
  "app.account_details.marketHolding": "Market value of holdings (USD)",
  "app.account_details.more": "More operations",
  "app.account_details.order": "Trade Order",
  "app.account_details.revenuesh": "Revenue Sharing",
  "app.account_details.riskMargin": "Risk Margin",
  "app.account_details.title": "Account Details",
  "app.account_details.toUpdate": "Click to Update",
  "app.account_details.totalAsset": "Total Asset (USD)",
  "app.account_details.totalCap": "Total capital allocation",
  "app.activity.title": "Activity Zone",
  "app.activitydetail.title": "Activity Details",
  "app.agency.agent_level1": "First level agent",
  "app.agency.agent_level2": "Secondary agent",
  "app.agency.agent_level3": "Third level agent",
  "app.agency.commision": "Commision Amount",
  "app.agency.deferred": "Deferred Fee",
  "app.agency.management": "Management Fee",
  "app.agency.profit": "Profit Share",
  "app.agency.promo": "Promotional Links",
  "app.agency.recharge": "Member Recharge Reward",
  "app.agency.team": "My Team",
  "app.agency.title": "Agent Account",
  "app.agency.transfer": "Fund Withdrawal & Transfer",
  "app.agency.withdraw": "Withdraw Amount",
  "app.agency_link.copycode": "Copy Promo Code",
  "app.agency_link.copylink": "Copy Link",
  "app.agency_link.method1": "Method 1 : Scan the QR code",
  "app.agency_link.method2": "Method 2 : Click the link to register",
  "app.agency_link.method3": "Method 3 : Enter the promotion code on the registration page",
  "app.agency_link.myQR": "My QR code",
  "app.agency_link.title": "My Promotional Link",
  "app.agent_commision_detail.accNum": "Account Number : ",
  "app.agent_commision_detail.amount": "Amount : ",
  "app.agent_commision_detail.balance": "Balance : ",
  "app.agent_commision_detail.title": "Commision",
  "app.agent_transfer_withdrawal.accBalance": "Account Balance",
  "app.agent_transfer_withdrawal.dsc": "Fund transfer: Funds are transferred from the promotion account to the member account and the funds are transferred immediately.",
  "app.agent_transfer_withdrawal.title": "Withdraw/Transfer",
  "app.agent_transfer_withdrawal.transfer": "Transfer",
  "app.agent_transfer_withdrawal.transferAm": "Withdraw / Transfer Amount",
  "app.agent_transfer_withdrawal.transferAm_placeholder": "Please entert the Transfer Amount",
  "app.agent_transfer_withdrawal.transfer_sure": "Are you sure want to Transfer ",
  "app.agent_transfer_withdrawal.transfer_sure1": " to your member account? ",
  "app.agent_transfer_withdrawal.transfer_title": "Confirm Transfer",
  "app.agent_transfer_withdrawal.warn1": "The amount you entered is incorrect",
  "app.agent_transfer_withdrawal.withdraw": "Withdraw",
  "app.agent_transfer_withdrawal.withdraw_sure": "Are you sure want to withdraw ",
  "app.agent_transfer_withdrawal.withdraw_title": "Confirm Withdrawal",
  "app.agent_withdraw_details.amount": "Amount : ",
  "app.agent_withdraw_details.balance": "Balance : ",
  "app.agent_withdraw_details.title": "Withdraw Amount",
  "app.announcement.title": "Announcement",
  "app.bind_bank.bank": "Bank",
  "app.bind_bank.bank_address": "Bank Location",
  "app.bind_bank.bank_address_dsc": "Please enter your Bank Location",
  "app.bind_bank.bank_select": "Click to choose the Bank",
  "app.bind_bank.bank_select_dsc": "Please choose a bank",
  "app.bind_bank.card": "Bank card number",
  "app.bind_bank.card_dsc": "Please enter your bank card number",
  "app.bind_bank.name": "Account holder's name",
  "app.bind_bank.name_dsc": "Please enter your name",
  "app.bind_bank.title": "Bind Bank Card",
  "app.bind_email.email": "Email Adress",
  "app.bind_email.email_placeholder": "Please enter your Email Adress",
  "app.bind_email.get_code": "Get code",
  "app.bind_email.sms_verification": "SMS verification code",
  "app.bind_email.sms_verification_placeholder": "Please enter the verification code received in your new email address",
  "app.bind_email.title": "Email",
  "app.bind_phone.current_mobile": "Current Phone Number",
  "app.bind_phone.get_code": "Get code",
  "app.bind_phone.new_mobile": "New Phone Number",
  "app.bind_phone.new_mobile_dsc": "Please enter your new phone number",
  "app.bind_phone.sms_verification": "SMS verification code",
  "app.bind_phone.sms_verification_dsc": "Please Enter SMS verification code ",
  "app.bind_phone.sms_verification_placeholder": "SMS verification code",
  "app.bind_phone.title": "Change Phone Number",
  "app.capital_fund_details.title": "Fund details",
  "app.capitalaccount.balance": "Available balance",
  "app.capitalaccount.create_capital": "Create Capital",
  "app.capitalaccount.cumulative_profit_loss": "Cumulative profit & loss",
  "app.capitalaccount.current_capital": "Current Capital",
  "app.capitalaccount.history_capital": "Hitstory Capital",
  "app.capitalaccount.information": "Account Info",
  "app.capitalaccount.loss_liquidation": "Loss liquidation line",
  "app.capitalaccount.loss_warning": "Loss warning line",
  "app.capitalaccount.profit_loss": "Profit loss",
  "app.capitalaccount.risk_margin": "Risk Margin",
  "app.capitalaccount.short_trading": "Short Trading",
  "app.capitalaccount.title": "Margin Trading",
  "app.capitalaccount.total_asset": "Current Total Asset",
  "app.capitalaccount.total_capital_allocation": "Total capital",
  "app.capitalaccount.trade_capital": "Trade Capital",
  "app.capitalaccount.trading": "Long Trading",
  "app.channelroom.pw_error": "Password error",
  "app.channelroomuser.error_sending": "Error sending message, please try again",
  "app.channelsearch.pw_error": "Password error",
  "app.closed_Capital_info.application_amount": "Application amount",
  "app.closed_Capital_info.buy_sell_sts": "Buy/Sell/Status",
  "app.closed_Capital_info.contactnum": "Contract Number",
  "app.closed_Capital_info.deduction": "Deductions",
  "app.closed_Capital_info.distribution_profit_loss": "Distribution of trading profits and losses",
  "app.closed_Capital_info.freez": "Freeze",
  "app.closed_Capital_info.loss_compension": "Loss compensation",
  "app.closed_Capital_info.loss_stop_line": "Loss stop-loss line",
  "app.closed_Capital_info.loss_warning_line": "Loss warning line",
  "app.closed_Capital_info.management_fee": "Management Fee",
  "app.closed_Capital_info.margin_settlement": "Margin Settlement",
  "app.closed_Capital_info.namecode": "Name code",
  "app.closed_Capital_info.price_qty": "Price/Quantity",
  "app.closed_Capital_info.profit_dist": "Profit distribution",
  "app.closed_Capital_info.profit_loss_ratio": "Profit&Loss Ratio",
  "app.closed_Capital_info.revenue_sharing": "Revenue Sharing",
  "app.closed_Capital_info.risk_margin": "Risk Margin",
  "app.closed_Capital_info.thaw": "Thaw",
  "app.closed_Capital_info.time": "Transaction time",
  "app.closed_Capital_info.title": "Closed Capital Info",
  "app.closed_Capital_info.total_capital_allocation": "Total capital allocation",
  "app.closed_Capital_info.total_trade_capital": "Total trading capital",
  "app.closed_Capital_info.trade_instrument": "Trading instruments",
  "app.closed_Capital_info.trade_profit_loss": "Trading profit and loss",
  "app.closed_Capital_info.transaction_flow": "Transaction flow (click to view more details)",
  "app.common.account": "UserAccount",
  "app.common.back": "Return",
  "app.common.cancel": "cancel",
  "app.common.chat": "Chat",
  "app.common.confirm": "confirm",
  "app.common.currency": "$",
  "app.common.enter_sms_code": "enter the verification code",
  "app.common.finished": "No more",
  "app.common.home": "Home",
  "app.common.loading": "Loading...",
  "app.common.not_logged_in": "You aren't logged in",
  "app.common.phone_wrong_format": "phone number format is incorrect",
  "app.common.phone_wrong_format2": "The two passwords are different, please re-enter",
  "app.common.stock": "Stocks",
  "app.common.sure": "Modify",
  "app.common.trade": "Trading",
  "app.createcapital.Agreement": "《Golden Bull US Stocks Limited Service Agreement》",
  "app.createcapital.account_balance": "Account Balance :",
  "app.createcapital.apply_amount": "Apply Amount",
  "app.createcapital.apply_btn": "Apply Now",
  "app.createcapital.auto_extension": "Auto extension",
  "app.createcapital.capital": "Trade Capital",
  "app.createcapital.capital_info": "Min 2000,max 2 million,multiples of 100",
  "app.createcapital.capital_info_vip": "Min 100000,max 5 million,multiples of 100",
  "app.createcapital.consent": "Application Consent",
  "app.createcapital.create_capital": "Create Capital",
  "app.createcapital.daily_interest_rate": "Daily Interest Rate",
  "app.createcapital.day_capital": "Daily",
  "app.createcapital.day_contract": "Each contract has at least ",
  "app.createcapital.day_contract2": " trading days",
  "app.createcapital.day_contract3": "A 2-trading-day management fee will be charged for the first application",
  "app.createcapital.funds_plus_margin": "Financing funds + margin",
  "app.createcapital.holding_time": "Holding Time",
  "app.createcapital.interest_free_capital": "Interest Free",
  "app.createcapital.interest_free_rate": "Interest-free",
  "app.createcapital.login_first": "Please log in first",
  "app.createcapital.loss_line": "Loss stop-loss line",
  "app.createcapital.loss_warning": "Loss warning",
  "app.createcapital.month_capital": "Monthly",
  "app.createcapital.month_interest_rate": "Monthly Interest Rate",
  "app.createcapital.pre_management_fee": "Pre-deposited management fee",
  "app.createcapital.pre_management_fee_calc_day": "Financing amount × daily interest rate × 2",
  "app.createcapital.pre_management_fee_calc_month": "Financing amount x monthly interest rate",
  "app.createcapital.pre_management_fee_calc_week": "Financing amount x weekly interest rate",
  "app.createcapital.pull_refresh": "Pull down to Refresh",
  "app.createcapital.read_agreement": "Please read the agreement first",
  "app.createcapital.refresh": "Refresh",
  "app.createcapital.risk_margin": "Risk Margin",
  "app.createcapital.times": "Times",
  "app.createcapital.title": "Margin Trading",
  "app.createcapital.total_capital": "Total capital",
  "app.createcapital.total_payable": "Total Payable : ",
  "app.createcapital.trading_day": "Day",
  "app.createcapital.trading_month": "Month",
  "app.createcapital.trading_type": "Trading Type",
  "app.createcapital.trading_week": "Week",
  "app.createcapital.undestand": "I already understand",
  "app.createcapital.upto_30_days": "Upto 30 days",
  "app.createcapital.vip_capital": "VIP",
  "app.createcapital.voucher_balance": "Vouchers :",
  "app.createcapital.week_capital": "Weekly",
  "app.createcapital.week_interest_rate": "Weekly Interest Rate",
  "app.deal_inquiry.amount": "Transaction Amount",
  "app.deal_inquiry.buy": "Buy Amount: ",
  "app.deal_inquiry.commision": "Commision",
  "app.deal_inquiry.date": "Date : ",
  "app.deal_inquiry.delivery": "Settlement & Delivery",
  "app.deal_inquiry.direction": "Transaction Direction",
  "app.deal_inquiry.directionTrade": "Long/Short",
  "app.deal_inquiry.fees": "Fees",
  "app.deal_inquiry.frc": "FRC Transaction Levy",
  "app.deal_inquiry.levy": "Levy",
  "app.deal_inquiry.name": "Name Code",
  "app.deal_inquiry.pltFee": "Platform Fee",
  "app.deal_inquiry.price": "Transaction Price",
  "app.deal_inquiry.qty": "Transaction Quantity",
  "app.deal_inquiry.search": "Search",
  "app.deal_inquiry.select_date": "Select Date",
  "app.deal_inquiry.sell": "Sell Amount: ",
  "app.deal_inquiry.stamp": "Stamp Duty",
  "app.deal_inquiry.time": "Time",
  "app.deal_inquiry.title": "Deal Log",
  "app.deferred_cost.accNum": "Account Number : ",
  "app.deferred_cost.amount": "Amount : ",
  "app.deferred_cost.balance": "Balance : ",
  "app.deferred_cost.title": "Deferred Fee Detail",
  "app.detailed_log.all_detail": "All details",
  "app.detailed_log.balance": "Balance",
  "app.detailed_log.cash_back": "Cash back",
  "app.detailed_log.depositl": "Recharge details",
  "app.detailed_log.loan": "Loan details",
  "app.detailed_log.management_fee": "Management Fee",
  "app.detailed_log.profit_withdraw": "Profit Withdraw",
  "app.detailed_log.title": "Funding Details",
  "app.detailed_log.voucher": "Vouchers",
  "app.detailed_log.withdraw": "Withdraw details",
  "app.divided_cost.accNum": "Account Number : ",
  "app.divided_cost.amount": "Amount : ",
  "app.divided_cost.balance": "Balance : ",
  "app.divided_cost.title": "Profit Share Details",
  "app.entrust_inquiry.buy_sell": "Buy/Sell",
  "app.entrust_inquiry.buy_sell_state": "State",
  "app.entrust_inquiry.code": "Code",
  "app.entrust_inquiry.commision_price": "Commision Price",
  "app.entrust_inquiry.date": "Date :",
  "app.entrust_inquiry.direction": "Long/Short",
  "app.entrust_inquiry.order_qty": "Order Quantity",
  "app.entrust_inquiry.order_time": "Order Time",
  "app.entrust_inquiry.search": "Search",
  "app.entrust_inquiry.select_date": "Select Date",
  "app.entrust_inquiry.stock": "Stock",
  "app.entrust_inquiry.title": "Entrust Log",
  "app.entrust_inquiry.transaction_price": "Transaction Price",
  "app.entrust_inquiry.transaction_qty": "Transaction Quantity",
  "app.entrust_inquiry.transaction_time": "Transaction Time",
  "app.financefund.incorect_amount": "The amount entered is incorrect",
  "app.forget.card": "Card : ",
  "app.forget.card_placeholder": "Please enter the Card",
  "app.forget.complete": "Complete",
  "app.forget.forgetpass": "Forget Password",
  "app.forget.get_code": "Get Code",
  "app.forget.get_code_placeholder": "Please enter the SMS code",
  "app.forget.get_code_sms": "SMS code",
  "app.forget.password": "Password",
  "app.forget.passwordConfirm": "Confirm Password",
  "app.forget.passwordConfirm_placeholder": "Please re-enter the Password",
  "app.forget.password_placeholder": "Please enter the Password",
  "app.forget.phone": "Phone",
  "app.forget.phone_placeholder": "Please enter the phone number",
  "app.forget.real_name": "Real name : ",
  "app.forget.real_name_placeholder": "Please enter the real name",
  "app.forget.verification_code": "Verification Code",
  "app.forget.verification_code_placeholder": "Please enter the verification code",
  "app.foundwinner.change_price": "Price Increase",
  "app.foundwinner.focus_price": "Focus Price",
  "app.foundwinner.high_price": "High Price",
  "app.foundwinner.last_15_days": "Rates in the past 15 days",
  "app.foundwinner.latestStockPool": "Latest Stock Pool",
  "app.foundwinner.login_to_access": "You are not logged in yet, please log in",
  "app.foundwinner.more": "More",
  "app.foundwinner.regiter_to_read": "Register and Login to Read",
  "app.foundwinner.stock_name": "Stock Name",
  "app.friend_coupon.amount": "Amount",
  "app.friend_coupon.balance": "Balance:",
  "app.friend_coupon.code": "QR code / Link",
  "app.friend_coupon.details": "Details",
  "app.friend_coupon.dsc": "No friend cash coupon",
  "app.friend_coupon.expdate": "Expiry Date",
  "app.friend_coupon.giftdate": "Gift Date",
  "app.friend_coupon.instruction": "Instruction",
  "app.friend_coupon.status": "Status",
  "app.friend_coupon.title": "Friend Cash Coupon",
  "app.fund_details.title": "Fund Detail",
  "app.home.about_us": "About Us",
  "app.home.activity_zone": "Activity Zone",
  "app.home.app_download": "APP Download",
  "app.home.app_download1": "Safe capital allocation at Jinniu US stocks",
  "app.home.app_download2": "Well-known firms",
  "app.home.copyright": "(Investment is risky, please be cautious when entering the market)",
  "app.home.day_capital": "Day Capital",
  "app.home.error": "Loading error",
  "app.home.found_winner": "Found Winner",
  "app.home.interest_free_capital": "Interest Free Capital",
  "app.home.market_info": "Market Info",
  "app.home.month_capital": "Month Capital",
  "app.home.more": "More",
  "app.home.online_customer_service": "Customer Service",
  "app.home.week_capital": "Week Capital",
  "app.increase_bond_info.add": "Additional bond Amount",
  "app.increase_bond_info.add_aftr": "Total account balance after addition:",
  "app.increase_bond_info.add_immediate": "Apply now",
  "app.increase_bond_info.add_min": "Minimum additional amount",
  "app.increase_bond_info.add_plh": "Please enter the additional amount. Minimum amount: $100.",
  "app.increase_bond_info.bal": "Current balance",
  "app.increase_bond_info.num": "Contract Number",
  "app.increase_bond_info.title": "Additional Bond",
  "app.increase_bond_info.toalBal": "Current total account balance:",
  "app.increase_bond_info.warn1": "Please enter the additional amount",
  "app.increase_capital_info.add": "Additional Funding Amount",
  "app.increase_capital_info.add_aftr": "Total account balance after addition:",
  "app.increase_capital_info.add_immediate": "Apply now",
  "app.increase_capital_info.add_min": "Minimum additional amount",
  "app.increase_capital_info.add_plh": "Please enter the additional amount. Minimum amount: $100.",
  "app.increase_capital_info.bal": "Current balance",
  "app.increase_capital_info.num": "Contract Number",
  "app.increase_capital_info.title": "Additional Funding",
  "app.increase_capital_info.toalBal": "Current total account balance:",
  "app.increase_capital_info.warn1": "Please enter the additional amount",
  "app.information.bank_card": "Bank card",
  "app.information.bound": "Set",
  "app.information.email": "Email",
  "app.information.login_pass": "Login Password",
  "app.information.nick_name": "Nick Name",
  "app.information.nobound": "Not set",
  "app.information.notset": "Not set",
  "app.information.password": "Password",
  "app.information.phone": "Phone",
  "app.information.real_name": "Real Name",
  "app.information.set": "Set",
  "app.information.title": "Personal Information",
  "app.information.unname": "No realname",
  "app.information.withdraw_pass": "Withdraw Password",
  "app.kline.PE": "P/E",
  "app.kline.amplitude": "Amplitude",
  "app.kline.billion": "billion",
  "app.kline.buy": "Buy",
  "app.kline.circulation": "Circulation value",
  "app.kline.commision_ratio": "Commision ratio",
  "app.kline.day": "Day",
  "app.kline.favourite": "Favourite",
  "app.kline.highest": "Highest",
  "app.kline.in_hand": "in hand",
  "app.kline.in_hand_10": "thousand",
  "app.kline.in_hand_100": "million",
  "app.kline.low": "Low price",
  "app.kline.minute": "Minute",
  "app.kline.month": "Month",
  "app.kline.points": "Point",
  "app.kline.price_lm": "Price limit",
  "app.kline.sell": "Sell",
  "app.kline.thousand": "thousand",
  "app.kline.timeshare": "Timeshare",
  "app.kline.today_open": "Today Open",
  "app.kline.total_market": "Total market",
  "app.kline.trade_volume": "Trade volume",
  "app.kline.trans_volume": "Transaction volume",
  "app.kline.volume_drop": "52week drop price",
  "app.kline.volume_ratio": "52week volume ratio",
  "app.kline.week": "Week",
  "app.kline.yesterday_harvest": "Yesterday close price",
  "app.login.forgetpass": "Foget Password?",
  "app.login.login": "Login",
  "app.login.password": "Password",
  "app.login.password_placeholder": "Please enter your password",
  "app.login.phone_number": "Phone",
  "app.login.phone_number_placeholder": "Please enter your phone number",
  "app.login.register": "Register",
  "app.login_pass.confirm_pass": "Confirm Password",
  "app.login_pass.confirm_pass_dsc": "Please enter your Confirm Password",
  "app.login_pass.get_code": "Get code",
  "app.login_pass.login_pass": "Password",
  "app.login_pass.login_pass_dsc": "Please enter your Password",
  "app.login_pass.password_not_identical": "The passwords do not match, please re-enter",
  "app.login_pass.phone": "Phone Number",
  "app.login_pass.sms_verification": "SMS Verification code",
  "app.login_pass.sms_verification_dsc": "Please enter the SMS Verification code",
  "app.login_pass.sms_verification_placeholder": "Please enter the SMS Verification code",
  "app.login_pass.title": "Change Login Password",
  "app.login_pass.verification": "Verification code",
  "app.login_pass.verification_placeholder": "Please enter the Verification code",
  "app.manage_cost.accNum": "Account Number : ",
  "app.manage_cost.amount": "Amount : ",
  "app.manage_cost.balance": "Balance : ",
  "app.manage_cost.title": "Management Fee Detail",
  "app.members.agent_account": "Agent Account",
  "app.members.announcement": "Announcement",
  "app.members.balance": "Balance",
  "app.members.capital_account": "Capital Account",
  "app.members.checkIn": "checkIn",
  "app.members.create_capital": "Create Capital",
  "app.members.customer_service": "Contact Customer Service",
  "app.members.deal_log": "Deal Log",
  "app.members.depot_log": "Depot Log",
  "app.members.entrust_log": "Entrust Log",
  "app.members.first_recharge": "First Recharge Gift",
  "app.members.first_recharge_now": "Recharge",
  "app.members.friend_cash_coupon": "Friend Cash Coupon",
  "app.members.fundingDetails": "Funding details",
  "app.members.gxpay_desc": "(Third party digital currency)",
  "app.members.holiday_treasure": "Holiday Treasure",
  "app.members.immediate_trading": "Trade Now",
  "app.members.line1": "Line 1",
  "app.members.line2": "Line 2",
  "app.members.line3": "Line 3",
  "app.members.line_switch": "Line Switch",
  "app.members.live_trade": "Live Trading",
  "app.members.login": "Login",
  "app.members.logout": "Logout",
  "app.members.margin": "Margin",
  "app.members.my_cash_coupon": "My Cash Coupon",
  "app.members.personal_info": "Personal Info",
  "app.members.quotes": "Quotes",
  "app.members.realname_pop": "No real name yet",
  "app.members.realname_pop_bonus": "Bonus in dollars",
  "app.members.realname_pop_cancel": "Cancel",
  "app.members.realname_pop_real": "Real name",
  "app.members.realname_pop_reg": "Register to activate",
  "app.members.recharge": "Recharge",
  "app.members.register": "Register",
  "app.members.regular_treasure": "Regular Treasure",
  "app.members.risk_control": "Risk Control",
  "app.members.timebao": "Timebao",
  "app.members.timebao_desc": "Make money with Annualized return of",
  "app.members.title": "User Center",
  "app.members.totalprofit": "Cumulative Profit",
  "app.members.version": "Version / Description",
  "app.members.voucher": "Voucher",
  "app.members.withdraw": "Withdraw",
  "app.members.withdraw_log": "Order Cancel Log",
  "app.my_team.all_members": "All Members",
  "app.my_team.title": "My Team",
  "app.my_team.total_topup": "Total Recharge Amount :",
  "app.my_team.total_topup_membership": "Recharge Membership",
  "app.my_team.total_topup_non_membership": "No Recharge Membership",
  "app.news_info.error": "Loading error",
  "app.news_info.title": "News",
  "app.news_info_detailed.publisher": "Publisher : ",
  "app.news_info_detailed.title": "News",
  "app.nickname.enter_nick_name": "enter your nickname",
  "app.nickname.nick_name": "Nick Name",
  "app.nickname.title": "Modify Nick Name",
  "app.notice_detailed.title": "Notice",
  "app.position_inquiry.code": "Name Code",
  "app.position_inquiry.cost": "Cost",
  "app.position_inquiry.direction": "Long/Short",
  "app.position_inquiry.frozen": "Frozen Quantity",
  "app.position_inquiry.holding": "Total Holding",
  "app.position_inquiry.market": "Market Price",
  "app.position_inquiry.number": "Contract Number",
  "app.position_inquiry.openday": "Opening Date",
  "app.position_inquiry.price": "Current Price",
  "app.position_inquiry.profitloss": "Profit & Loss",
  "app.position_inquiry.sellable": "Sellable Quantity",
  "app.position_inquiry.title": "Position Log",
  "app.protocol.title": "Protocol",
  "app.protocol.wrong_entry": "Illegal entry",
  "app.quotes.all": "All US stocks",
  "app.quotes.code": "Stock Code",
  "app.quotes.latest_price": "Latest Price",
  "app.quotes.optional": "Favourite",
  "app.quotes.price_change": "Price Change",
  "app.quotes.title": "Stock Market",
  "app.quotes.trading_volume": "Volume",
  "app.quotes_detail.latest_price": "Latest Price",
  "app.quotes_detail.name": "Code/Name",
  "app.quotes_detail.rise": "Rise and Fall",
  "app.quotes_detail.title1": "All US stocks",
  "app.quotes_detail.title2": "All Hong Kong stocks",
  "app.quotes_detail.title3": "Hong Kong stocks rise",
  "app.quotes_detail.title4": "Hong Kong stocks down",
  "app.quotes_detail.title5": "Hong Kong stock turnover",
  "app.quotes_detail.title6": "Hong Kong stock trading volume",
  "app.quotes_detail.volume1": "Transaction amount/10,000",
  "app.quotes_detail.volume2": "Transaction volume/10,000",
  "app.real_name.first_recharge_gift": "First Recharge Gift",
  "app.real_name.first_recharge_gift_cancel": "Cancel",
  "app.real_name.first_recharge_gift_recharge": "Recharge Now",
  "app.real_name.id_card": "ID card",
  "app.real_name.id_card_msg": "Please enter your ID card",
  "app.real_name.real_name": "Real Name",
  "app.real_name.real_name_msg": "Please enter your Real Name",
  "app.real_name.title": "Real name Authentication",
  "app.recharge.activityzone": "Activity Zone",
  "app.recharge.amount_rmb": "Recharge amount (RMB)",
  "app.recharge.current_balance": "Current Balance : ",
  "app.recharge.dollar": " US dollar",
  "app.recharge.exchangeamt": "Exchange amount : ",
  "app.recharge.exchangefee": "Exchange Fee: ",
  "app.recharge.instruction": "Instruction",
  "app.recharge.instruction1": "Please be sure to retain the old card used for transfers, as this will result in a recharge failure. ",
  "app.recharge.instruction2": "Please use the trial deposit card provided by your brokerage firm.",
  "app.recharge.invalid": "Please enter the correct recharge amount",
  "app.recharge.invalid100": "The recharge amount must be greater than 100 yuan",
  "app.recharge.maxlimit": "The maximum amount of manual deposit is 2 million",
  "app.recharge.next": "Next Step",
  "app.recharge.next1": "Get a real-time deposit card and transfer money via mobile phone/computer/bank",
  "app.recharge.placeholder": "Enter the recharge amount, starting from 100 RMB",
  "app.recharge.ratio": "USD:RMB = ",
  "app.recharge.rmb1": "RMB ( ",
  "app.recharge.rmb2": " RMB )",
  "app.recharge.title": "Recharge Page",
  "app.recharge.type": "Recharge Type",
  "app.recharge.undestand": "I already understand",
  "app.recharge.yuan": "¥",
  "app.recharge_info.acc_name": "Account Name : ",
  "app.recharge_info.addr": "Payment address: ",
  "app.recharge_info.bank": "Receiving Bank: ",
  "app.recharge_info.card": "Payment card number: ",
  "app.recharge_info.copies": "Copied Successfully",
  "app.recharge_info.copy": "Copy",
  "app.recharge_info.ins": "Recharge Instructions:",
  "app.recharge_info.ins1": "1. Please do not retain the old card transfer, as this will result in a recharge failure.",
  "app.recharge_info.ins2": "2. Please use your own account to transfer funds to the following account via your phone, computer, or bank account.",
  "app.recharge_info.ins3": "3. After the transfer is successful, click 'I have transferred, request recharge' and the platform will confirm the transfer.",
  "app.recharge_info.ins4": "Instructions for use:",
  "app.recharge_info.ins5": "The recharge will be credited to your account within 3-10 minutes after the transfer. If it has not been credited to your account, please contact our online customer service or dedicated customer service.",
  "app.recharge_info.pay_amt": "Payment Amount:",
  "app.recharge_info.recharge": "Recharge",
  "app.recharge_info.reminder": "Reminder: ",
  "app.recharge_info.reminder1": "Please transfer the funds using your account ( ",
  "app.recharge_info.reminder2": " ) and click 'I have successfully paid' to deposit the funds. The transfer amount must match the system amount. If there are decimals, please include them. Otherwise, the funds will be credited the next day.",
  "app.recharge_info.success": "The recharge application is successful, please complete the subsequent operations as soon as possible and contact customer service",
  "app.recharge_info.title": "Recharge Information",
  "app.recharge_info.wrong_entry": "Illegal entry",
  "app.register.first_deposit": "First deposit",
  "app.register.get_code": "Get Code",
  "app.register.gift_money": "Gift money in US dollars",
  "app.register.loginNow": "Log in Now",
  "app.register.login_to_receive": "Please log in to receive",
  "app.register.newMember_gift": "New Member Gift",
  "app.register.newMember_gift1": "~The highest you can get~",
  "app.register.newMember_gift1_1": "Gift 1: New user registration gift",
  "app.register.password": "Password",
  "app.register.password_placeolder": "Please enter your password",
  "app.register.phone": "Phone",
  "app.register.phone_placeholder": "Please enter your phone number",
  "app.register.recommender": "Referred By",
  "app.register.recommender_placeholder": "Please enter a referrer",
  "app.register.register": "Register",
  "app.register.sms_code": "SMS code",
  "app.register.sms_code_placeholder": "Please enter the SMS verification code",
  "app.register.success": "You have successfully registered",
  "app.register.verification_code": "Verification Code",
  "app.register.verification_code_placeholder": "Please enter the verification code",
  "app.risk_control.title": "Risk Control",
  "app.timebao.annual_int": "Annual Interest",
  "app.timebao.balance": "Account Balance",
  "app.timebao.bill": "Bill",
  "app.timebao.cumulate_income": "Cumulative income",
  "app.timebao.current_asset": "Current Assets",
  "app.timebao.last_8_hr": "Last 8 hours profit",
  "app.timebao.title": "Time Bao",
  "app.timebao.transfer": "Transfer To TimeBao",
  "app.timebao.transferAm": "Transfer Amount : ",
  "app.timebao.transfer_from": "Transfer From TimeBao",
  "app.timebao.transfer_in": "Transfer In",
  "app.timebao.transfer_out": "Transfer Out",
  "app.timebao.transferable": "Transferable balance:",
  "app.timebao.transferring": "Transfer amount:",
  "app.timebao.warning": "Enter a valid amount",
  "app.timebao_detail.balance": "Balance:",
  "app.timebao_detail.date": "Date:",
  "app.timebao_detail.finish": "Finished",
  "app.timebao_detail.search": "Search",
  "app.timebao_detail.selectDate": "Select date",
  "app.timebao_detail.title": "Time Bao Details",
  "app.trading.1/3": "1/3rd",
  "app.trading.availablebuy": "Max Open",
  "app.trading.availablesell": "Max Close",
  "app.trading.balance": "Balance:",
  "app.trading.buy": "Open",
  "app.trading.buy1": "Buy1",
  "app.trading.confirm": "Confirm the transaction",
  "app.trading.dealpop_amt": "Transaction amount",
  "app.trading.dealpop_code": "Stock Code",
  "app.trading.dealpop_commision": "Commision",
  "app.trading.dealpop_delivery_fee": "Settlement and delivery fees",
  "app.trading.dealpop_fee": "Transaction Fee",
  "app.trading.dealpop_frc": "FRC Transaction Levy",
  "app.trading.dealpop_levy": "Transaction Levy",
  "app.trading.dealpop_name": "Name",
  "app.trading.dealpop_plt_fee": "Platform fees",
  "app.trading.dealpop_price": "Transaction price",
  "app.trading.dealpop_qty": "Transaction quantity",
  "app.trading.dealpop_stamp": "Stamp Duty",
  "app.trading.dealpop_sum": "Lump Sum",
  "app.trading.dealpop_time": "Date and Time",
  "app.trading.empty": "Empty",
  "app.trading.full": "Max",
  "app.trading.half": "Half",
  "app.trading.limitprice": "Limit Price",
  "app.trading.market": "Market",
  "app.trading.market_buy": "Market Price",
  "app.trading.market_sell": "Market Price",
  "app.trading.marketprice": "Market Price",
  "app.trading.sell": "Close",
  "app.trading.sell1": "Sell1",
  "app.trading.short": "Short",
  "app.trading.trade": "Long Trading",
  "app.trading.tradeD": "Short Trading",
  "app.trading.undestand": "I already understand",
  "app.trading.warn1": "The current minimum unit of stock price is ",
  "app.trading.warn2": "Please enter the stock trading price ",
  "app.trading.warn3": "Please enter the trading stock code ",
  "app.trading.warn4": "Please enter the number of shares to be traded ",
  "app.trading.warn5": "Are you sure you want to buy this stock?",
  "app.trading.warn6": "Are you sure you want to sell this stock?",
  "app.trading.warn7": "You are about to cancel this stock, do you want to continue?",
  "app.trading.warn8": "There is no margin contract yet, please complete the margin contract first",
  "app.tradingColumns.buy_sell_qty": "Buy/Sell qty",
  "app.tradingColumns.cancel": "Canceled Order",
  "app.tradingColumns.commision_time": "Time",
  "app.tradingColumns.deal": "Deal",
  "app.tradingColumns.delegation_status": "Deleg/Status",
  "app.tradingColumns.entrust": "Entrust",
  "app.tradingColumns.entrust_transaction": "Entrust/Trans",
  "app.tradingColumns.fee": "Fee",
  "app.tradingColumns.market_value": "Market value",
  "app.tradingColumns.name": "Name code",
  "app.tradingColumns.position": "Position",
  "app.tradingColumns.position_available": "Position/Avail",
  "app.tradingColumns.position_availablesell": "Positions/Available sale",
  "app.tradingColumns.price_cost": "Price/cost",
  "app.tradingColumns.price_total": "Price/Total",
  "app.tradingColumns.profit_loss": "Profit&Loss",
  "app.user_coupon.date": "Valid until : ",
  "app.user_coupon.dsc": "I don't have any cash coupons yet",
  "app.user_coupon.p1": "Cash coupon: Recharge over ",
  "app.user_coupon.p2": "Requirements: After allocating funds, the purchase amount reaches ",
  "app.user_coupon.p3": "Withdrawable in USD ",
  "app.user_coupon.title": "My Cash Coupon",
  "app.user_coupon.use": "To use",
  "app.voucher_cost.accNum": "Account Number : ",
  "app.voucher_cost.amount": "Amount : ",
  "app.voucher_cost.balance": "Balance : ",
  "app.voucher_cost.title": "Member Recharge Rewards",
  "app.withdraw.accInfo": "Account Information",
  "app.withdraw.amt": "Withdrawal amount: ",
  "app.withdraw.amt_plh": "Minimum withdrawal amount: 100 yuan",
  "app.withdraw.bankb": "The bank card has not been bound yet. Please go and bind the bank card before you can withdraw cash.",
  "app.withdraw.cancel": "Cancel",
  "app.withdraw.changePW": "Change withdrawal password",
  "app.withdraw.confirm": "Confirm withdrawal",
  "app.withdraw.continue": "Continue Withdrawal",
  "app.withdraw.curBal": "Current balance: ",
  "app.withdraw.currency": "Withdrawal currency (RMB)",
  "app.withdraw.exchange": "Exchange amount: ",
  "app.withdraw.gx_plh": "Enter your Gxpay ID",
  "app.withdraw.popup": "You have not set a withdrawal password, so you cannot withdraw money. Please go and set it.",
  "app.withdraw.popup2": "Please set up a bank card before you can withdraw cash",
  "app.withdraw.pwd": "Withdraw Password : ",
  "app.withdraw.pwd_plh": "Please enter the withdrawal password",
  "app.withdraw.ratio": "RMB:USD=",
  "app.withdraw.reminder": "Friendly reminder",
  "app.withdraw.reminder1": "Transfer to ShiShiBao, earn every 8 hours",
  "app.withdraw.reminder2": "%Trade stocks during market hours and manage finances during market hours, making money anytime In and out anytime, with real-time payment and annualized rate of return",
  "app.withdraw.reminder3": "Transfer to ShiShiBao",
  "app.withdraw.reminder4": "Continue to withdraw",
  "app.withdraw.reminder_first": "Warm reminder:",
  "app.withdraw.rmb": "RMB",
  "app.withdraw.same": "You have submitted a withdrawal of the same amount and it is under review.\nIf it is not a new withdrawal, please do not submit it again. Tips",
  "app.withdraw.select": "Please select the withdrawal type",
  "app.withdraw.success": "Withdrawal successful",
  "app.withdraw.title": "Withdrawal Page",
  "app.withdraw.undestand": "I already understand",
  "app.withdraw.verified": "Verified",
  "app.withdraw.warn1": "Please enter the withdrawal amount",
  "app.withdraw.warn2": "Please enter the withdrawal password",
  "app.withdraw.warn3": "Please enter your GXPay ID",
  "app.withdraw.warn4": "Please check your Gxpay ID before confirming the withdrawal operation",
  "app.withdraw_pass.confirm_pass": "Confirm Password",
  "app.withdraw_pass.confirm_pass_dsc": "Please enter your Confirm Password",
  "app.withdraw_pass.get_code": "Get code",
  "app.withdraw_pass.phone": "Phone Number",
  "app.withdraw_pass.sms_verification": "SMS Verification code",
  "app.withdraw_pass.sms_verification_dsc": "Please enter the SMS Verification code",
  "app.withdraw_pass.sms_verification_placeholder": "Please enter the SMS Verification code",
  "app.withdraw_pass.title": "Change Withdraw Password",
  "app.withdraw_pass.verification": "Verification code",
  "app.withdraw_pass.verification_placeholder": "Please enter the Verification code",
  "app.withdraw_pass.withdraw_pass": "Password",
  "app.withdraw_pass.withdraw_pass_dsc": "Please enter your Password",
  "app.withdrawal_inquiry.direction": "Entrust direction",
  "app.withdrawal_inquiry.name": "Name Code",
  "app.withdrawal_inquiry.price": "Price",
  "app.withdrawal_inquiry.quantity": "Order Quantity",
  "app.withdrawal_inquiry.status": "Order Status",
  "app.withdrawal_inquiry.time": "Order Time",
  "app.withdrawal_inquiry.title": "Order Cancel Log",
  "app.withdrawal_inquiry.trade_direction": "Long/Short",
  "app.withdrawal_inquiry.unsold": "Unsold Quantity",
  "app.withdrawalpass.password_not_identical": "Password not identical, please re-enter",
  "system.ActivityInfo.account_insufficient_funds": "Your account has insufficient funds",
  "system.ActivityInfo.already_experienced_free_funding": "You have already experienced free funding",
  "system.ActivityInfo.free_funding_application_failed": "Free funding application failed",
  "system.ActivityInfo.free_funding_application_success": "Free funding application successful",
  "system.AgentCreate.agent_already_opened": "Agent already opened",
  "system.AgentCreate.agent_opened_failed": "Agent opened failed",
  "system.AgentCreate.agent_opened_success": "Agent opened successful",
  "system.AgentInfo.account_balance_insufficient": "Your account balance is insufficient",
  "system.AgentInfo.amount_input_error": "Amount input error",
  "system.AgentInfo.fund_transfer_failed": "Fund transfer failed",
  "system.AgentInfo.fund_transfer_success": "Fund transfer successful",
  "system.AgentInfo.no_promotion_code_contact_service": "No promotion code, please contact customer service",
  "system.AgentInfo.transfer_amount_input_error": "Transfer amount input error",
  "system.AgentInfo.withdrawal_application_failed": "Withdrawal application failed",
  "system.AgentInfo.withdrawal_application_success": "Withdrawal application successful",
  "system.AutoClose.margin_call_fail": "Margin call failed",
  "system.AutoClose.margin_call_sucesss": "Margin call successful",
  "system.AutoClose.order_sell_fail": "Order sale failed",
  "system.AutoClose.order_sell_suceess": "Order sale successful",
  "system.AutoDepot.purchase_failed": "Purchase failed",
  "system.AutoDepot.purchase_success": "Purchase successful",
  "system.AutoDepot.sell_stock_failed": "Stock sale failed",
  "system.AutoDepot.sell_stock_success": "Stock sale successful",
  "system.Banks.account_holder_name_cannot_be_empty": "Account holder name cannot be empty",
  "system.Banks.account_holder_name_inconsistent_with_verification": "Account holder name inconsistent with verification name",
  "system.Banks.bank_branch_cannot_be_empty": "Bank branch cannot be empty",
  "system.Banks.bank_card_number_cannot_be_empty": "Bank card number cannot be empty",
  "system.Banks.bank_card_number_format_error": "Bank card number format error",
  "system.Banks.bank_name_cannot_be_empty": "Bank name cannot be empty",
  "system.Banks.bank_not_open": "This bank not yet open",
  "system.Banks.bind_failed": "Binding failed",
  "system.Banks.bind_success": "Binding successful",
  "system.Banks.first_real_name_verification_to_bind_bank_card": "First real name verification to bind bank card",
  "system.Banks.modify_failed": "Modification failed",
  "system.Banks.modify_success": "Modification successful",
  "system.CancelEntrust.batch_cancel_entrust_failed": "Batch cancel entrust failed",
  "system.CancelEntrust.batch_cancel_entrust_success": "Batch cancel entrust successful",
  "system.CancelEntrust.cancel_entrust_order_failed": "Cancel entrust order failed",
  "system.CancelEntrust.cancel_entrust_order_not_exists": "Cancel entrust order does not exist",
  "system.CancelEntrust.cancel_entrust_order_success": "Cancel entrust order successful",
  "system.CancelEntrust.cancel_order_success": "Cancel the order successfully",
  "system.CancelEntrust.entrust_order_id_not_exists": "Entrust order ID does not exist",
  "system.CancelEntrust.funding_info_not_exists": "Funding information does not exist",
  "system.CancelEntrust.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.CancelEntrust.no_entrust_info": "No entrust information",
  "system.CancelEntrust.position_info_not_exists": "Position information does not exist",
  "system.CapitalHistory.funding_unique_id_not_passed": "Funding unique ID not passed",
  "system.CapitalOperate.account_balance_insufficient": "Your account balance is insufficient",
  "system.CapitalOperate.account_balance_insufficient_exclamation": "Your account balance is insufficient!",
  "system.CapitalOperate.account_insufficient_funds": "Your account has insufficient funds",
  "system.CapitalOperate.additional_amount_format_error": "Additional amount format error",
  "system.CapitalOperate.additional_amount_must_not_less_than_0": "Additional amount must not be less than 0",
  "system.CapitalOperate.additional_funding_amount_must_be_100_multiple": "Additional funding amount must be multiple of 100",
  "system.CapitalOperate.additional_funding_amount_must_not_less_than_0": "Additional funding amount must not be less than 0",
  "system.CapitalOperate.additional_funding_failed": "Additional funding failed",
  "system.CapitalOperate.additional_funding_success": "Additional funding successful",
  "system.CapitalOperate.additional_margin_failed": "Additional margin failed",
  "system.CapitalOperate.additional_margin_success": "Additional margin successful",
  "system.CapitalOperate.free_funding_cannot_withdraw_profit": "Free funding cannot withdraw profit!",
  "system.CapitalOperate.minimum_additional_amount": "Minimum additional capital has been met",
  "system.CapitalOperate.minimum_additional_funding_amount": "Minimum additional capital reached",
  "system.CapitalOperate.please_enter_additional_amount": "Please enter additional amount",
  "system.CapitalOperate.please_enter_additional_funding_amount": "Please enter additional funding amount",
  "system.CapitalOperate.please_enter_withdrawal_amount": "Please enter withdrawal amount",
  "system.CapitalOperate.please_select_funding_order": "Please select funding order",
  "system.CapitalOperate.profit_amount_insufficient": "Insufficient profit amount",
  "system.CapitalOperate.sorry_function_not_yet_open": "Sorry, this function is not yet open!",
  "system.CapitalOperate.withdraw_profit_failed": "Withdraw profit failed",
  "system.CapitalOperate.withdraw_profit_success": "Withdraw profit successful",
  "system.CapitalOperate.withdrawal_amount_format_error": "Withdrawal amount format error",
  "system.CapitalOperate.withdrawal_amount_must_greater_than_0": "Withdrawal amount must be greater than 0",
  "system.CapitalWith.account_insufficient_funds": "Your account has insufficient funds",
  "system.CapitalWith.funding_application_failed": "Funding application failed",
  "system.CapitalWith.funding_application_success": "Funding application successful",
  "system.CapitalWith.funding_multiple_selection_error": "Funding multiple selection error",
  "system.CapitalWith.margin_must_be_100_multiple": "Margin must be multiple of 100",
  "system.CapitalWith.maximum_risk_margin": "Higher risk margin",
  "system.CapitalWith.minimum_risk_margin": "Lower risk margin",
  "system.CapitalWith.not_yet_open": "Not yet open",
  "system.CapitalWith.please_enter_risk_margin": "Please enter risk margin",
  "system.CapitalWith.please_select_funding_multiple": "Please select funding multiple",
  "system.CapitalWith.please_select_operation_type": "Please select operation type",
  "system.Capital_model.funding_info_not_exists": "Funding information does not exist",
  "system.Capital_model.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.Concern.add_to_watchlist_failed": "Add to watchlist failed",
  "system.Concern.add_to_watchlist_success": "Add to watchlist successful",
  "system.Concern.code_cannot_be_empty": "Code cannot be empty",
  "system.Concern.code_not_exists": "Code does not exist",
  "system.Concern.remove_from_watchlist_failed": "Remove from watchlist failed",
  "system.Concern.remove_from_watchlist_success": "Remove from watchlist successful",
  "system.Concern.remove_from_watchlist_success_simple": "Remove from watchlist successful",
  "system.Concern.stock_not_yet_open": "This stock is not yet open",
  "system.ExactLog.profit_withdrawal": "Profit withdrawal",
  "system.Finance.account_insufficient_funds": "Your account has insufficient funds",
  "system.Finance.delete_operation_failed": "Delete operation failed",
  "system.Finance.deleted": "Deleted",
  "system.Finance.disagree_transaction_channel": "Disagree transaction channel",
  "system.Finance.minimum_withdrawal_amount": "Need to apply for a withdrawal amount greater than the minimum",
  "system.Finance.please_bind_bank_card": "Please bind bank card",
  "system.Finance.please_enter_application_amount": "Please enter application amount",
  "system.Finance.please_enter_gxpay_id": "Please enter your GXPay ID",
  "system.Finance.please_enter_recharge_amount": "Please enter recharge amount",
  "system.Finance.please_enter_withdrawal_password": "Please enter withdrawal password",
  "system.Finance.please_select_recharge_type": "Please select recharge type",
  "system.Finance.recharge_amount_must_be_100_multiple": "Recharge amount must be multiple of 100",
  "system.Finance.recharge_amount_must_be_integer": "Recharge amount must be integer",
  "system.Finance.recharge_application_failed": "Recharge application failed",
  "system.Finance.recharge_application_success": "Recharge application successful",
  "system.Finance.recharge_confirmation": "Recharge confirmation",
  "system.Finance.recharge_confirmation_operation_failed": "Recharge confirmation operation failed",
  "system.Finance.recharge_type_selection_error": "Recharge type selection error",
  "system.Finance.withdrawal_amount_must_be_integer": "Withdrawal amount must be integer",
  "system.Finance.withdrawal_application_failed": "Withdrawal application failed",
  "system.Finance.withdrawal_application_success": "Withdrawal application successful",
  "system.Finance.withdrawal_password_input_error": "Withdrawal password input error",
  "system.Finance.withdrawal_password_not_set": "Withdrawal password not set",
  "system.FinanceDetail_model.is_repeat_no": "No",
  "system.FinanceDetail_model.is_repeat_yes": "Yes",
  "system.FinanceDetail_model.period_months_suffix": "months",
  "system.FinanceDetail_model.period_weeks_suffix": "days",
  "system.FinanceFund.account_insufficient_balance": "Account balance insufficient",
  "system.FinanceFund.fund_transfer_in_failed": "Fund transfer in failed",
  "system.FinanceFund.fund_transfer_in_success": "Fund transfer in successful",
  "system.FinanceFund.fund_transfer_out_failed": "Fund transfer out failed",
  "system.FinanceFund.fund_transfer_out_success": "Fund transfer out successful",
  "system.FinanceFund.idle_money_manager_type_not_found": "Idle money manager type not found",
  "system.FinanceFund.investable_balance_insufficient": "Insufficient investable balance",
  "system.FinanceFund.investment_fail": "Investment failure",
  "system.FinanceFund.investment_sucess": "Investment success",
  "system.FinanceFund.no_settlement_document_selected": "No settlement document selected",
  "system.FinanceFund.please_enter_amount": "Please enter amount",
  "system.FinanceFund.please_enter_correct_amount": "Please enter correct amount",
  "system.FinanceFund.please_select_idle_money_manager_type": "Please select idle money manager type",
  "system.FinanceFund.settlement_document_not_found": "Settlement document not found",
  "system.FinanceFund.settlement_failed": "Settlement failed",
  "system.FinanceFund.settlement_success": "Settlement successful",
  "system.FinanceFund.transferable_amount_insufficient": "Insufficient transferable amount",
  "system.FirstVoucher.already_signed_today_next_trading_day": "You have already signed in today, come back next trading day!",
  "system.FirstVoucher.backend_bonus": "Backend Bonus",
  "system.FirstVoucher.batch_process_cash_failed": "Batch process cash failed!",
  "system.FirstVoucher.batch_process_voucher_failed": "Batch process voucher failed!",
  "system.FirstVoucher.capital_allocate": "'s interest fee",
  "system.FirstVoucher.deposit_bonus": "Deposit Bonus",
  "system.FirstVoucher.event_bonus": "Event Bonus",
  "system.FirstVoucher.first_deposit_bonus": "First Deposit Bonus",
  "system.FirstVoucher.first_recharge_batch_process_success": "First recharge batch process successful",
  "system.FirstVoucher.first_trade_bonus": "First Transaction Bonus",
  "system.FirstVoucher.real_name_bonus": "Real-name Bonus",
  "system.FirstVoucher.sign_bonus": "Sign-up Bonus",
  "system.FirstVoucher.sign_in_bonus": "Sign-in Bonus",
  "system.FirstVoucher.signin_success_congratulations_voucher": "Sign in successful",
  "system.FirstVoucher.trial_bonus": "Trial Bonus",
  "system.FirstVoucher.voucher_bounus": "Voucher Usage",
  "system.FirstVoucher.welcome_signin_non_trading_day": "Welcome to sign in, today is a non-trading day!",
  "system.FirstVoucher.winning_bonus": "Winning Bonus",
  "system.ForgetPassword.new_password_cannot_be_empty": "New password cannot be empty",
  "system.ForgetPassword.new_password_must_be_6_to_12_digits": "New password must be 6-12 digits",
  "system.ForgetPassword.phone_number_format_incorrect": "Phone number format incorrect",
  "system.ForgetPassword.phone_number_incorrect": "Phone number incorrect",
  "system.ForgetPassword.phone_number_not_registered": "This phone number not registered",
  "system.ForgetPassword.phone_verification_code_incorrect": "Phone verification code incorrect",
  "system.ForgetPassword.please_enter_phone_verification_code": "Please enter phone verification code",
  "system.ForgetPassword.please_enter_registration_phone_number": "Please enter registration phone number",
  "system.ForgetPassword.retrieve_login_password_failed": "Retrieve login password failed",
  "system.ForgetPassword.retrieve_login_password_success": "Retrieve login password successful",
  "system.ForgetPassword.two_password_inputs_inconsistent": "Two password inputs inconsistent",
  "system.FriendCoupon.friend_voucher_generation_complete": "Friend voucher generation complete",
  "system.HolidayFund.account_insufficient_balance": "Account balance insufficient",
  "system.HolidayFund.auto_transfer_modify_success": "Auto transfer modification successful",
  "system.HolidayFund.fund_transfer_failed": "Fund transfer failed",
  "system.HolidayFund.fund_transfer_in_failed": "Fund transfer in failed",
  "system.HolidayFund.fund_transfer_in_success": "Fund transfer in successful",
  "system.HolidayFund.fund_transfer_successful": "Fund transfer successful",
  "system.HolidayFund.holiday_account_not_found": "Holiday account not found",
  "system.HolidayFund.insufficient_investable_balance": "Insufficient investable balance",
  "system.HolidayFund.insufficient_transferable_amountt": "Insufficient transferable amount",
  "system.HolidayFund.investment_failed": "Investment failed",
  "system.HolidayFund.investment_successful": "Investment successful",
  "system.HolidayFund.no_settlement_document_found": "No settlement document found",
  "system.HolidayFund.no_settlement_document_selected": "No settlement document selected",
  "system.HolidayFund.please_enter_amount": "Please enter amount",
  "system.HolidayFund.please_enter_correct_amount": "Please enter correct amount",
  "system.HolidayFund.please_select_holiday_product": "Please select holiday product",
  "system.HolidayFund.product_not_found": "Festival Treasure product not found",
  "system.HolidayFund.settlement_failed": "Settlement failed",
  "system.HolidayFund.settlement_successf": "Settlement successful",
  "system.HolidayType_model.period_days_suffix": "days",
  "system.Home.no_activity": "No activity!",
  "system.Home1.no_activity": "No activity!",
  "system.KLine.illegal_input": "Illegal input",
  "system.KLine.kline_type_not_specified": "K-line type not specified!",
  "system.KLine.stock_code_not_specified": "Stock code not specified!",
  "system.LoanLog.apply_finance": "Additional margin financing",
  "system.LoanLog.apply_margin": "Apply for margin financing",
  "system.Login.information_error": "Information error!",
  "system.Login.login_failed": "Login failed",
  "system.Login.login_success": "Login successful",
  "system.Login.no_permission": "You have no permission",
  "system.Login.phone_encryption_end": "Phone encryption end",
  "system.Login.phone_or_password_error": "Phone number or login password error",
  "system.Login.please_enter_login_password": "Please enter login password",
  "system.Login.please_enter_phone_number": "Please enter phone number",
  "system.ManageLog.management_fee": "Management Fees",
  "system.Member.agent_opened_failed": "Agent opened failed",
  "system.Member.agent_opened_success": "Agent opened successful",
  "system.Member.already_real_name_verified": "Already real name verified",
  "system.Member.confirm_password_cannot_be_empty": "Confirm password cannot be empty",
  "system.Member.contact_service_complete_real_name_verification": "Please contact customer service to complete real name verification before operating forget password.",
  "system.Member.email_format_error": "Email format error",
  "system.Member.email_verification_code_error": "Email verification code error",
  "system.Member.id_number_format_error": "ID number format error",
  "system.Member.modify_failed": "Modify failed",
  "system.Member.modify_phone_failed": "Modify phone number failed",
  "system.Member.modify_phone_success": "Modify phone number successful",
  "system.Member.modify_success": "Modify successful",
  "system.Member.new_password_must_be_6_to_12_digits": "New password must be 6-12 digits",
  "system.Member.nickname_modify_failed": "Nickname modification failed",
  "system.Member.nickname_modify_success": "Nickname modification successful",
  "system.Member.operation_failed": "Operation failed",
  "system.Member.operation_success": "Operation successful",
  "system.Member.phone_number_format_error": "Phone number format error",
  "system.Member.phone_verification_code_error": "Phone verification code error",
  "system.Member.please_contact_service": "Please contact customer service",
  "system.Member.please_enter_email": "Please enter email",
  "system.Member.please_enter_email_verification_code": "Please enter email verification code",
  "system.Member.please_enter_id_number": "Please enter ID number",
  "system.Member.please_enter_new_password": "Please enter new password",
  "system.Member.please_enter_nickname": "Please enter nickname",
  "system.Member.please_enter_phone_number": "Please enter phone number",
  "system.Member.please_enter_phone_verification_code": "Please enter phone verification code",
  "system.Member.please_enter_real_name": "Please enter real name",
  "system.Member.real_name_format_error": "Real name format error",
  "system.Member.real_name_verification_application_failed": "Real name verification application failed",
  "system.Member.real_name_verification_application_success": "Real name verification application successful",
  "system.Member.two_password_inputs_inconsistent": "Two password inputs inconsistent",
  "system.Member.user_already_used": "This user already used",
  "system.Member.verification": "Verification",
  "system.NewsCenter.news_not_found": "News not found",
  "system.NewsCenter.please_pass_news_unique_id": "Please pass news unique ID",
  "system.Notice_model.date_format": "Y年m月d日",
  "system.Nozzle.abnormal_login_please_relogin": "Abnormal login, please login again",
  "system.Nozzle.data_normal": "Data normal",
  "system.Nozzle.login_timeout_please_relogin": "Login timeout, please login again",
  "system.Offline.disagree_transaction_channel": "Disagree transaction channel",
  "system.Offline.fast_channel_temporarily_closed_contact_service": "Fast channel temporarily closed, please contact online customer service",
  "system.Offline.order_failed_large_amount_contact_service": "Order failed, large amount please contact online customer service",
  "system.Offline.please_contact_online_service": "Please contact online customer service",
  "system.Offline.please_do_not_frequent_operation_wait_3min": "Please do not frequent operation, wait 3 minutes before trying again",
  "system.Offline.please_enter_recharge_amount": "Please enter recharge amount",
  "system.Offline.please_go_real_name_verification": "Please go for real name verification",
  "system.Offline.please_select_fixed_amount": "Please select fixed amount",
  "system.Offline.please_select_recharge_type": "Please select recharge type",
  "system.Offline.recharge_amount_must_be_100_multiple": "Recharge amount must be multiple of 100",
  "system.Offline.recharge_amount_must_be_integer": "Recharge amount must be integer",
  "system.Offline.recharge_amount_must_be_over_100": "Recharge amount must be over 100",
  "system.Offline.recharge_application_failed": "Recharge application failed",
  "system.Offline.recharge_application_success_contact_service": "Recharge application successful, complete follow-up operations quickly, contact customer service",
  "system.Offline.recharge_type_selection_error": "Recharge type selection error",
  "system.PayBasic.recharge_application_failed": "Recharge application failed",
  "system.PayBasic.recharge_application_success": "Recharge application successful",
  "system.PayFive.abnormal_login_please_relogin": "Abnormal login, please login again",
  "system.PayFive.application_failed": "Application failed",
  "system.PayFive.application_success": "Application successful",
  "system.PayFive.bank_card_format_error": "Bank card number format error",
  "system.PayFive.login_timeout_please_relogin": "Login timeout, please login again",
  "system.PayFive.payment_bank_not_open": "Payment bank not yet open",
  "system.PayFive.please_enter_recharge_amount": "Please enter recharge amount",
  "system.PayFive.please_select_payment_bank": "Please select payment bank",
  "system.PayFive.please_select_payment_bank_card": "Please select payment bank card number",
  "system.PayFive.quick_pay_minimum_20_yuan": "Quick pay minimum recharge 20 yuan",
  "system.PayOne.abnormal_login_please_relogin": "Abnormal login, please login again",
  "system.PayOne.login_timeout_please_relogin": "Login timeout, please login again",
  "system.PayOne.please_bind_bank_card": "Please bind bank card",
  "system.PayOne.please_enter_recharge_amount": "Please enter recharge amount",
  "system.PayOne.please_real_name_verification": "Please real name verification",
  "system.PayOne.recharge_application_failed": "Recharge application failed",
  "system.PayOne.recharge_application_success": "Recharge application successful",
  "system.PhoneCode.enter_registration_phone_number": "Enter registration phone number",
  "system.PhoneCode.name_or_id_number_error": "The name or ID number you entered is incorrect",
  "system.PhoneCode.phone_number_already_registered": "Phone number already registered",
  "system.PhoneCode.phone_number_format_incorrect": "Phone number format incorrect",
  "system.PhoneCode.phone_number_not_registered": "Phone number not registered",
  "system.PhoneCode.please_enter_correct_captcha": "Please enter correct captcha",
  "system.PhoneCode.please_try_again_later": "Please try again later",
  "system.PhoneCode.send_failed": "Send failed",
  "system.PhoneCode.type_error": "Type error",
  "system.PhoneCode.verification_code_sent_success": "Your verification code sent successfully, please check",
  "system.PhoneCode.verification_code_valid_5min_too_frequent": "Verification code valid for 5 minutes, you sent too frequently, please try later",
  "system.Protocols.please_enter_protocol_unique_id": "Please enter protocol unique ID",
  "system.RealCancelEntrust.batch_cancel_entrust_failed": "Batch cancel entrust failed",
  "system.RealCancelEntrust.batch_cancel_entrust_success": "Batch cancel entrust successful",
  "system.RealCancelEntrust.cancel_entrust_order_failed": "Cancel entrust order failed",
  "system.RealCancelEntrust.cancel_entrust_order_not_exists": "Cancel entrust order does not exist",
  "system.RealCancelEntrust.cancel_entrust_order_success": "Cancel entrust order successful",
  "system.RealCancelEntrust.entrust_order_id_not_exists": "Entrust order ID does not exist",
  "system.RealCancelEntrust.funding_info_not_exists": "Funding information does not exist",
  "system.RealCancelEntrust.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.RealCancelEntrust.no_entrust_info": "No entrust information",
  "system.RealCancelEntrust.position_info_not_exists": "Position information does not exist",
  "system.RealCapitalHistory.funding_unique_id_not_passed": "Funding unique ID not passed",
  "system.RealCapitalOperate.account_balance_insufficient": "Your account balance is insufficient",
  "system.RealCapitalOperate.account_balance_insufficient_exclamation": "Your account balance is insufficient!",
  "system.RealCapitalOperate.additional_amount_format_error": "Additional amount format error",
  "system.RealCapitalOperate.additional_amount_must_not_less_than_0": "Additional amount must not be less than 0",
  "system.RealCapitalOperate.additional_funding_amount_must_be_100_multiple": "Additional funding amount must be multiple of 100",
  "system.RealCapitalOperate.additional_funding_amount_must_not_less_than_0": "Additional funding amount must not be less than 0",
  "system.RealCapitalOperate.additional_funding_failed": "Additional funding failed",
  "system.RealCapitalOperate.additional_funding_success": "Additional funding successful",
  "system.RealCapitalOperate.additional_margin_failed": "Additional margin failed",
  "system.RealCapitalOperate.additional_margin_success": "Additional margin successful",
  "system.RealCapitalOperate.free_funding_cannot_withdraw_profit": "Free funding cannot withdraw profit!",
  "system.RealCapitalOperate.minimum_additional_amount": "Minimum additional amount {amount} yuan",
  "system.RealCapitalOperate.minimum_additional_funding_amount": "Minimum additional funding amount {amount} yuan",
  "system.RealCapitalOperate.please_enter_additional_amount": "Please enter additional amount",
  "system.RealCapitalOperate.please_enter_additional_funding_amount": "Please enter additional funding amount",
  "system.RealCapitalOperate.please_enter_withdrawal_amount": "Please enter withdrawal amount",
  "system.RealCapitalOperate.please_select_funding_order": "Please select funding order",
  "system.RealCapitalOperate.profit_amount_insufficient": "Insufficient profit amount",
  "system.RealCapitalOperate.withdraw_profit_failed": "Withdraw profit failed",
  "system.RealCapitalOperate.withdraw_profit_success": "Withdraw profit successful",
  "system.RealCapitalOperate.withdrawal_amount_format_error": "Withdrawal amount format error",
  "system.RealCapitalOperate.withdrawal_amount_must_greater_than_0": "Withdrawal amount must be greater than 0",
  "system.RealCapitalWith.account_insufficient_funds": "Your account has insufficient funds",
  "system.RealCapitalWith.funding_application_failed": "Funding application failed",
  "system.RealCapitalWith.funding_application_success": "Funding application successful",
  "system.RealCapitalWith.funding_multiple_selection_error": "Funding multiple selection error",
  "system.RealCapitalWith.margin_must_be_100_multiple": "Margin must be multiple of 100",
  "system.RealCapitalWith.maximum_risk_margin": "Maximum risk margin {amount}",
  "system.RealCapitalWith.minimum_risk_margin": "Minimum risk margin {amount}",
  "system.RealCapitalWith.not_yet_open": "Not yet open",
  "system.RealCapitalWith.please_enter_risk_margin": "Please enter risk margin",
  "system.RealCapitalWith.please_select_funding_multiple": "Please select funding multiple",
  "system.RealCapitalWith.please_select_operation_type": "Please select operation type",
  "system.RealCapital_model.funding_info_not_exists": "Funding information does not exist",
  "system.RealCapital_model.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.RealDeal_model.market_price_prefix": "Market Price",
  "system.RealDeal_model.type_buy": "Buy",
  "system.RealDeal_model.type_sell": "Sell",
  "system.RealEntrust_model.status_cancelled": "Cancelled",
  "system.RealSettlement.entrust_orders_unprocessed_cannot_settle": "You have unprocessed entrust orders, cannot settle temporarily",
  "system.RealSettlement.funding_settlement_failed": "Funding settlement failed",
  "system.RealSettlement.funding_settlement_success": "Funding settlement successful",
  "system.RealSettlement.position_orders_unprocessed_cannot_settle": "You have unprocessed position orders, cannot settle temporarily",
  "system.RealSettlement.settlement_cycle_minimum_two_days": "Settlement cycle minimum is two days",
  "system.RealTradeBuy.buy_price_format_error": "Buy price format error",
  "system.RealTradeBuy.buy_quantity_cannot_be_empty": "Buy quantity cannot be empty",
  "system.RealTradeBuy.buy_quantity_format_error": "Buy quantity format error",
  "system.RealTradeBuy.buy_quantity_must_be_100_multiple": "Buy quantity must be multiple of 100",
  "system.RealTradeBuy.entrust_failed": "Entrust failed",
  "system.RealTradeBuy.entrust_success": "Entrust successful",
  "system.RealTradeBuy.funding_account_insufficient_funds": "Your funding account has insufficient funds",
  "system.RealTradeBuy.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.RealTradeBuy.please_enter_stock_code": "Please enter stock code",
  "system.RealTradeBuy.purchase_failed": "Purchase failed",
  "system.RealTradeBuy.selected_funding_info_not_exists": "Selected funding information does not exist",
  "system.RealTradeSell.entrust_failed": "Entrust failed",
  "system.RealTradeSell.entrust_success": "Entrust successful",
  "system.RealTradeSell.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.RealTradeSell.please_enter_sell_quantity": "Please enter sell quantity",
  "system.RealTradeSell.please_enter_stock_code": "Please enter stock code",
  "system.RealTradeSell.position_info_not_exists": "Position information does not exist",
  "system.RealTradeSell.selected_funding_info_not_exists": "Selected funding information does not exist",
  "system.RealTradeSell.sell_price_format_error": "Sell price format error",
  "system.RealTradeSell.sell_quantity_format_error": "Sell quantity format error",
  "system.RealTradeSell.sell_quantity_must_greater_than_100": "Sell quantity must be greater than 100",
  "system.RealTradeSell.sell_stock_failed": "Sell stock failed",
  "system.RealTradeSell.sell_stock_success": "Sell stock successful",
  "system.RealTradeSell.stock_limit_down_trading_prohibited": "Stock limit down trading prohibited",
  "system.RealTradeSell.stock_temporarily_unavailable": "Stock temporarily unavailable for trading",
  "system.RealTradeSell.stock_today_trading_restricted": "This stock has restricted trading today",
  "system.RealTradeSell.today_tradeable_quantity_insufficient": "Insufficient tradeable quantity today",
  "system.Recharge_model.operation_failed": "Operation failed",
  "system.Recharge_model.operation_success": "Operation successful",
  "system.Recharge_model.third_party_updated_confirmation": "Please confirm if a third party has already made updates!",
  "system.RecommendShare.parameter_value_invalid": "Parameter value invalid",
  "system.RecommendShare.please_enter_category": "Please enter category",
  "system.RecommendShare.recharge_insufficient": "Insufficient recharge",
  "system.Register.cash_voucher_already_used": "Cash voucher already used",
  "system.Register.cash_voucher_unavailable": "Cash voucher unavailable",
  "system.Register.login_password_format_error": "Login password must be 6-12 letters + numbers",
  "system.Register.phone_number_already_registered": "Phone number already registered",
  "system.Register.phone_number_format_error": "Phone number format error",
  "system.Register.phone_number_mismatch": "Phone number and received phone number do not match",
  "system.Register.phone_verification_code_error": "Phone verification code error",
  "system.Register.please_enter_login_password": "Please enter login password",
  "system.Register.please_enter_phone_number": "Please enter phone number",
  "system.Register.please_enter_phone_verification_code": "Please enter phone verification code",
  "system.Register.registration_failed": "Registration failed",
  "system.Register.registration_success": "Registration successful",
  "system.RiskControls.approching_warning_line": "Yuan, approaching the warning line",
  "system.RiskControls.away_from_liquidation_line": "Yuan, away from the liquidation line",
  "system.RiskControls.close_the_possition_balance": "Close position.Balance",
  "system.RiskControls.close_to_the_liquidation": "Close to the liquidation threshold",
  "system.RiskControls.contract_balance": "Contract balance",
  "system.RiskControls.current_market_capitalization": "Yuan, current market capitalization",
  "system.RiskControls.dear_customer_your_account": "Dear Customer, Your account",
  "system.RiskControls.dear_customer_your_contract_number": "Dear Customer, Your Contract Number",
  "system.RiskControls.gem_star_board_position_ratio_limit": "GEM or STAR board single stock position ratio cannot exceed 100%",
  "system.RiskControls.individual_stock_position_exceeds_limit": "Individual stock cumulative position exceeds limit",
  "system.RiskControls.insufficient_funds": "Insufficient funds",
  "system.RiskControls.loan_amount": "Loan amount",
  "system.RiskControls.loss_exceeds_warning_line_trading_prohibited": "Loss exceeds warning line, trading prohibited",
  "system.RiskControls.margin": "Yuan, Margin",
  "system.RiskControls.margin_call_required": "Yuan, margin call required",
  "system.RiskControls.max_min_price_limit_exceeded": "Maximum/minimum price limit exceeded (9 times or 1/9 of closing price)",
  "system.RiskControls.maximum_price_trading_restricted": "Maximum price trading restricted",
  "system.RiskControls.member_account": "Member Account",
  "system.RiskControls.please_recharge_your_margin_to_avoid_losses": "Please promptly top up your margin to avoid losses resulting from the system automatically closing your positions.",
  "system.RiskControls.position_info_not_exists": "Position information does not exist",
  "system.RiskControls.profit_loss": "Yuan, profit and loss",
  "system.RiskControls.right_to_close_positions_our_discretion": "In accordance with the contractual terms, we reserve the right to close positions at our discretion. Please monitor developments promptly.",
  "system.RiskControls.stock_accumulated_over_50million_prohibited": "Stock accumulated over 50 million, trading prohibited",
  "system.RiskControls.stock_not_open_for_trading": "This stock is not yet open for trading",
  "system.RiskControls.stock_temporarily_prohibited_contact_service": "This stock temporarily prohibited, please contact customer service",
  "system.RiskControls.stock_today_trading_restricted": "This stock has restricted trading today",
  "system.RiskControls.stock_trading_prohibited": "This stock trading prohibited",
  "system.RiskControls.subject_to_contract_termination": "Dear Customer, Your account is currently in arrears and will be subject to contract termination",
  "system.RiskControls.suspended_stock_trading_prohibited": "Suspended stock trading prohibited",
  "system.RiskControls.system_has_closed_and_settled": "The position has expired, and the system has closed and settled it in accordance with the agreed terms.",
  "system.RiskControls.today_tradeable_quantity_insufficient": "Insufficient tradeable quantity today",
  "system.RiskControls.with_losses_exceeding": "Yuan, with losses exceeding",
  "system.RiskControls.yuan": "Yuan",
  "system.Settlement.entrust_orders_unprocessed_cannot_settle": "You have unprocessed entrust orders, cannot settle temporarily",
  "system.Settlement.funding_settlement_failed": "Funding settlement failed",
  "system.Settlement.funding_settlement_success": "Funding settlement successful",
  "system.Settlement.position_orders_unprocessed_cannot_settle": "You have unprocessed position orders, cannot settle temporarily",
  "system.StockPrice.no_candlestick_type": "No candlestick type specified!",
  "system.StockPrice.no_symbol": "No stock symbol specified!",
  "system.Stocks.current_stock_market_closed_cannot_trade": "Current stock market closed, cannot trade",
  "system.Stocks.current_stock_trading_prohibited": "Current stock trading prohibited",
  "system.Stocks.please_enter_correct_code": "Please enter correct code",
  "system.Test.abnormal_login_please_relogin": "Abnormal login, please login again",
  "system.Test.data_normal": "Data normal",
  "system.Test.login_timeout_please_relogin": "Login timeout, please login again",
  "system.TimebaoFund.account_insufficient_balance": "Account balance insufficient",
  "system.TimebaoFund.account_not_found": "Timebao account not found",
  "system.TimebaoFund.fund_transfer_in_failed": "Fund transfer in failed",
  "system.TimebaoFund.fund_transfer_in_success": "Fund transfer in successful",
  "system.TimebaoFund.fund_transfer_out_failed": "Fund transfer out failed",
  "system.TimebaoFund.fund_transfer_out_success": "Fund transfer out successful",
  "system.TimebaoFund.initialize_valid_principal": "Initialize valid principal",
  "system.TimebaoFund.interest_calculation_failed": "Interest calculation failed",
  "system.TimebaoFund.interest_calculation_success": "Interest calculation successful",
  "system.TimebaoFund.modify_success": "Modification successful",
  "system.TimebaoFund.no_balance": "No balance",
  "system.TimebaoFund.no_interest": "No interest",
  "system.TimebaoFund.please_enter_amount": "Please enter amount",
  "system.TimebaoFund.please_enter_correct_amount": "Please enter correct amount",
  "system.TimebaoFund.transferable_amount_insufficient": "Insufficient transferable amount",
  "system.TimebaoFund.user_interest_already_calculated": "User interest already calculated",
  "system.TradeBuy.account_abnormal_contact_service": "Account abnormal, please contact customer service",
  "system.TradeBuy.account_expired_buy_prohibited": "Account expired, buying prohibited",
  "system.TradeBuy.buy_price_error": "Buy price error",
  "system.TradeBuy.buy_price_format_error": "Buy price format error",
  "system.TradeBuy.buy_quantity_cannot_be_empty": "Buy quantity cannot be empty",
  "system.TradeBuy.buy_quantity_format_error": "Buy quantity format error",
  "system.TradeBuy.entrust_failed": "Entrust failed",
  "system.TradeBuy.entrust_success": "Entrust successful",
  "system.TradeBuy.funding_account_insufficient_funds": "Your funding account has insufficient funds",
  "system.TradeBuy.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.TradeBuy.market_closed_cannot_trade": "Market closed, cannot trade",
  "system.TradeBuy.minimum_buy_amount_limit": "Minimum buy amount is ({amount}) HKD",
  "system.TradeBuy.please_enter_stock_code": "Please enter stock code",
  "system.TradeBuy.please_enter_trade_quantity": "Please enter trade quantity",
  "system.TradeBuy.purchase_failed": "Purchase failed",
  "system.TradeBuy.purchase_success": "Purchase successful",
  "system.TradeBuy.stock_trading_suspended": "This stock trading is suspended",
  "system.TradeSell.account_abnormal_contact_service": "Account abnormal, please contact customer service",
  "system.TradeSell.entrust_failed": "Entrust failed",
  "system.TradeSell.entrust_success": "Entrust successful",
  "system.TradeSell.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.TradeSell.individual_stock_position_exceeds_limit": "Individual stock cumulative position exceeds limit",
  "system.TradeSell.loss_exceeds_warning_line_trading_prohibited": "Loss exceeds warning line, trading prohibited",
  "system.TradeSell.market_closed_cannot_trade": "Market closed, cannot trade",
  "system.TradeSell.max_min_price_limit_exceeded": "Maximum/minimum price limit exceeded (9 times or 1/9 of closing price)",
  "system.TradeSell.please_enter_sell_quantity": "Please enter sell quantity",
  "system.TradeSell.please_enter_stock_code": "Please enter stock code",
  "system.TradeSell.please_enter_trade_quantity": "Please enter trade quantity",
  "system.TradeSell.position_info_not_exists": "Position information does not exist",
  "system.TradeSell.purchase_failed": "Purchase failed",
  "system.TradeSell.sell_price_format_error": "Sell price format error",
  "system.TradeSell.sell_quantity_format_error": "Sell quantity format error",
  "system.TradeSell.sell_stock_failed": "Sell stock failed",
  "system.TradeSell.sell_stock_success": "Sell stock successful",
  "system.TradeSell.stock_not_open_for_trading": "This stock is not yet open for trading",
  "system.TradeSell.stock_temporarily_unavailable": "Stock temporarily unavailable for trading",
  "system.TradeSell.stock_today_trading_restricted": "This stock has restricted trading today",
  "system.TradeSell.stock_trading_suspended": "This stock trading is suspended",
  "system.TradeSell.today_tradeable_quantity_insufficient": "Insufficient tradeable quantity today",
  "system.WebNozzle.android_download": "Android download",
  "system.WebNozzle.apple_android_download": "Apple/Android download",
  "system.WebNozzle.ios_download": "iOS download",
  "system.WebNozzle.wechat_official_account": "Follow our WeChat Official Account",
  "system.WebNozzle.wechat_subscription_account": "Follow our WeChat subscription account",
  "system.Withdraw_model.fund_withdrawal": "Fund Withdrawal",
  "system.Withdraw_model.status_completed": "Completed",
  "system.Withdraw_model.status_rejected": "Rejected",
  "system.Withdraw_model.status_under_review": "Under Review",
  "system.YuebaoFund.account_insufficient_balance": "Account balance insufficient",
  "system.YuebaoFund.account_not_found": "Yuebao account not found",
  "system.YuebaoFund.fund_transfer_in_failed": "Fund transfer in failed",
  "system.YuebaoFund.fund_transfer_in_success": "Fund transfer in successful",
  "system.YuebaoFund.fund_transfer_out_failed": "Fund transfer out failed",
  "system.YuebaoFund.fund_transfer_out_success": "Fund transfer out successful",
  "system.YuebaoFund.investment_balance_insufficient": "Insufficient investable balance",
  "system.YuebaoFund.modify_success": "Modification successful",
  "system.YuebaoFund.no_settlement_document_selected": "No settlement document selected",
  "system.YuebaoFund.please_enter_amount": "Please enter amount",
  "system.YuebaoFund.please_enter_correct_amount": "Please enter correct amount",
  "system.YuebaoFund.settlement_document_not_found": "Settlement document not found",
  "system.YuebaoFund.settlement_failed": "Settlement failed",
  "system.YuebaoFund.settlement_success": "Settlement successful",
  "system.YuebaoFund.transferable_amount_insufficient": "Insufficient transferable amount",
  "system.YuebaoFund.transferred_to_yuebao_failed": "Failed to transfer to Yuebao wealth management",
  "system.YuebaoFund.transferred_to_yuebao_success": "Successfully transferred to Yuebao wealth management",
  "app.common.release_to_reload": "Release to refresh...",
  "app.common.pull_to_reload": "Pull down to refresh...",
  "system.Member.please_contact_service_to_obtain_your_card_number": "Please contact our online customer service to obtain your card number.",
  "system.Offline.success": "Success",
  "app.download.popup_testflight": "Apple anti-crash version",
  "app.download.popup_vueandrod": "Android Pro",
  "app.download.popup_applefree": "Apple free upgrade version",
  "app.download.popup_androidfree": "Android free upgrade version",
  "app.download.popup_nativeapp_android": "Android Classic Edition",
  "app.download.popup_nativeapp_ios": "Apple Classic Edition",
  "app.download.popup_dnzqandroid": "Golden Bull Securities Android version",
  "app.download.popup_dnzqapple": "Golden Bull Securities Apple Version",
  "app.download.popup_dnzqappletf": "Golden Bull Securities Apple TF",
  "app.download.popup_mac": "MAC desktop",
  "app.download.popup_windows": "Windows Desktop",
  "app.agency_transfer_withdrawal.bind_bank": "The bank card has not been bound yet. Please go and bind the bank card before you can withdraw cash.",
  "app.channel_room.group_pw": "Enter group password",
  "app.common.success": "Success",
  "app.members.recharge_application_success": "The recharge application is successful. Please complete the subsequent operations as soon as possible and contact customer service.",
  "app.recharge_info.repeat_submission": "Please confirm that you have paid! Repeated submission will affect the arrival time",
  "app.recharge_info.hint": "hint",
  "app.activities.title": "Activity Introduction",
  "app.gxpay.account": "Gxpay Account",
  "app.gxpay.id": "Gxpay ID",
  "app.gxpay.balance": "Gxpay Balance",
  "app.gxpay.buy": "Buy Coin",
  "app.gxpay.sell": "Sell coin",
  "app.gxpay.orderlist": "My Orders",
  "app.kline.name": "Japanese K",
  "app.popupcontent.title": "Recharge Guide",
  "app.members.platform_transfer": "Fund transfer",
  "app.platformtransfer.dnzq": "Taurus Securities",
  "app.platformtransfer.dnhk": "Taurus Hong Kong Stocks",
  "app.platformtransfer.transfer_to": "Transfer to",
  "app.platformtransfer.currency": "USD",
  "app.platformtransfer.order_number": "Order Number",
  "app.platformtransfer.central_system_number": "Central System Number",
  "app.platformtransfer.transfer_amount": "Transfer Amount",
  "app.platformtransfer.account_balance": "Account Balance",
  "app.platformtransfer.transfer_operation_type": "Transfer Operation Type",
  "app.platformtransfer.accessed_platform": "Accessed Platform",
  "app.platformtransfer.create_time": "Creation Time",
  "app.platformtransfer.transfer_details": "Fund transfer details",
  "system.platformtransfer.central_config": "Central configuration is now disabled. Please contact customer service.",
  "system.platformtransfer.only_two_decimals": "Only 2 decimal places are allowed.",
  "app.trading.shares": "Shares",
  "app.trading.buy_button": "Open Long",
  "app.trading.sell_button": "Close Long",
  "app.trading.sell_button_short": "Open Short",
  "app.trading.buy_button_short": "Close Short",
  "app.cuc.amount_received": "Amount Received",
  "app.cuc.dn_currency": "¥",
  "app.cuc.hk_currency": "HK dollar",
  "app.quotes.short_trading_stocks": "Today Short Tickers",
  "app.quotes.long_trading_stocks": "Today Long Tickers",
  "system.RiskControls.system_is_busy": "The system is currently busy, please try again later",
  "system.TradeSell.stock_transaction_failed": "The stock transaction failed",
  "system.platformtransfer.transfer_failed_account_holder_not_match": "The transfer failed because the account holder information did not match.",
  "app.createcapital.capital_direction": "Capital Direction",
  "app.createcapital.longDirection": "Long Trading",
  "app.createcapital.shortDirection": "Short Trading",
  "app.trading.trading_activity_fee": "Trading Activity Fee",
  "system.TradeBuy.daily_limit_open_error": "This sub-account has reached the daily limit for opening positions",
  "system.TradeBuy.single_stock_ratio_error": "It has exceeded the holding ratio of a single stock",
  "app.quotes.top_gainers": "Top Gainers",
  "app.quotes.top_losers": "Top Losers",
  "app.quotes.market_cap": "Market Cap",
  "app.quotes.24h_volume": "24h Volume"
};



// WEBPACK FOOTER //
// ./src/lang/en.js